module.exports = __webpack_public_path__ + "static/cg_role_178_0004fbeb033.wav";